import {Component} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatCard } from '@angular/material/card';
import {HeadlineTextComponent} from "../../../shared/components/headline-text/headline-text.component";

@Component({
    selector: 'not-found-404',
    templateUrl: './appointment-not-found.component.html',
    styleUrls: ['./appointment-not-found.component.scss'],
    standalone: true,
    imports: [MatCard, TranslateModule, HeadlineTextComponent]
})
export class AppointmentNotFoundComponent {
}
